import { createContext } from 'react';

import type { DragAndDropProviderProps } from './drag-and-drop.types';

// Handlers context for dynamic values that change frequently
export interface HandlersContextValue
  extends Pick<
    DragAndDropProviderProps,
    'onReorder' | 'onError' | 'canDrop' | 'canDrag' | 'announcements'
  > {}

export const HandlersContext = createContext<HandlersContextValue | null>(null);
